module.exports = __webpack_public_path__ + "static/media/3DPPA26.986595fe.jpg";